export default "__VITE_ASSET__3ed37cc8__"